
// SVG Icon: plus-list-20
export default { id: "terriajs-plus-list-20" };
export const id = "terriajs-plus-list-20";
export const name = "plus-list-20";
